"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedGuestChatAnswer =
/*#__PURE__*/
function (_pb_1$GuestChatAnswer) {
  _inherits(ExtendedGuestChatAnswer, _pb_1$GuestChatAnswer);

  function ExtendedGuestChatAnswer(properties) {
    var _this;

    _classCallCheck(this, ExtendedGuestChatAnswer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedGuestChatAnswer).call(this, properties));
    _this.type = ExtendedGuestChatAnswer.type;
    _this.booking = properties.request.booking;
    _this.bookingNo = properties.request.proxy.bookingNo;
    _this.chreqid = properties.request.proxy.chreqid;
    _this.guest = properties.request.proxy.guest;
    _this.property = properties.request.proxy.property;
    return _this;
  }

  _createClass(ExtendedGuestChatAnswer, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.request.proxy.property).concat(ExtendedGuestChatAnswer.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.GuestChatAnswer.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedGuestChatAnswer(pb_1.GuestChatAnswer.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedGuestChatAnswer;
}(pb_1.GuestChatAnswer);

ExtendedGuestChatAnswer.type = "GuestChatAnswer";
ExtendedGuestChatAnswer.context = "/guest-chat/answer";
exports.GuestChatAnswer = ExtendedGuestChatAnswer;